import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const Default = ({ post }: IProps) => {
	const urlObj = new URL(post.permalink);
	const target = urlObj.hostname !== window.location.hostname ? '_blank' : '_self';
	const displayDate = post.display_date;

	return (
		<a href={post.permalink} target={target} rel="noreferrer" className="pfa-card-default">
			{!!post.featured_image && (
				<figure
					className="pfa-card-default__img-wrapper"
					dangerouslySetInnerHTML={{ __html: post.featured_image }}
				/>
			)}
			<div className="pfa-card-default__text">
				<div className="pfa-card-default__meta">
					{(post.category.name || post.post_type_label) && (
						<p
							className="pfa-card-default__tag post-tag"
							dangerouslySetInnerHTML={{
								__html: sanitizeHtml(post.category.name || post.post_type_label),
							}}
						/>
					)}
					{displayDate && <p className="pfa-card-default__date">{displayDate}</p>}
				</div>
				<div className="pfa-card-default__content">
					{post.post_title && (
						<h3
							className="pfa-card-default__title"
							dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
						/>
					)}
				</div>
			</div>
		</a>
	);
};

Default.displayName = 'Default';

export default Default;
